export const ADMIN_ROUTE ='/admin'
export const LOGIN_ROUTE ='/login'
export const REG_ROUTE ='/registration'
export const SHOP_ROUTE ='/devices'
export const BASKET_ROUTE ='/basket'
export const PROFILE_ROUTE ='/profile'
export const DEVICES_ROUTE ='/devices'
export const DEVICE_ROUTE = DEVICES_ROUTE + "/:id"